import { message } from 'antd'
import serviceInterface from '../../services/service.interface'
import ActionType from '../action.types'

/*
Actions to be dispatched for exercises
- Inprogress
    action to dispatch incase of operation in progress
- set exercises
    action to dispatch incase to push all exercises
*/

export function operationInProgress(isLoading) {
  return {
    type: ActionType.EXER_INPROGRESS,
    isLoading,
  }
}

export function setExercises({ exercises }) {
  return {
    type: ActionType.EXER_SET_EXERCISES,
    exercises,
  }
}

export function getAllExercises(customerid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .ExerciseService()
        .getAllExercises(customerid)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else dispatch(setExercises(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}
export function getRangeExercises({ patientid, startdate, enddate }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .ExerciseService()
        .getRangeExercises(patientid, startdate, enddate)
      dispatch(operationInProgress(false))
      if (data.error) return false
      else return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}
